'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CloseButton = require('../CloseButton');

var _CloseButton2 = _interopRequireDefault(_CloseButton);

var _SideDrawerToggle = require('./SideDrawerToggle');

var _SideDrawerToggle2 = _interopRequireDefault(_SideDrawerToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SideDrawer = function (_PureComponent) {
  _inherits(SideDrawer, _PureComponent);

  function SideDrawer(props) {
    _classCallCheck(this, SideDrawer);

    var _this = _possibleConstructorReturn(this, (SideDrawer.__proto__ || Object.getPrototypeOf(SideDrawer)).call(this, props));

    _this.toggleDrawer = function () {
      _this.setState({ drawerOpen: !_this.state.drawerOpen });
    };

    _this.state = {
      drawerOpen: false
    };
    return _this;
  }

  _createClass(SideDrawer, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var drawerOpen = this.state.drawerOpen;

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(_SideDrawerToggle2.default, { onClick: this.toggleDrawer }),
        _react2.default.createElement(
          'div',
          { className: 'SideDrawer ' + (drawerOpen ? 'expanded' : '') },
          _react2.default.createElement(
            'div',
            { className: 'SideDrawer-inner' },
            _react2.default.createElement(_CloseButton2.default, {
              className: 'SideDrawer-close-btn',
              onClick: this.toggleDrawer
            }),
            children
          )
        ),
        _react2.default.createElement('div', {
          className: 'SideDrawer-background ' + (drawerOpen ? 'expanded' : '')
        })
      );
    }
  }]);

  return SideDrawer;
}(_react.PureComponent);

exports.default = SideDrawer;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Utility/SideDrawer/index.js
// module id = 246
// module chunks = 0